import React from 'react';
import { FormLabel as ControlLabel, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles(({ palette }) => ({
  label: {
    display: 'flex',
    color: palette.ddSelector.color,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    marginBottom: 0
  },
  error: {
    color: '#a94442'
  }
}));

function FormLabel({
  isRequired, title, isValid, className 
}) {
  const classes = useStyles();

  return (
    <ControlLabel className={`${classes.label} ${!isValid ? classes.error : ''} ${className} control-label`} required={isRequired}>
      {title}
    </ControlLabel>
  );
}

FormLabel.propTypes = {
  isRequired: PropTypes.bool,
  isValid: PropTypes.bool,
  title: PropTypes.string,
  className: PropTypes.string
};
FormLabel.defaultProps = {
  isRequired: false,
  isValid: true,
  title: '',
  className: ''
};

export default FormLabel; 